import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import Ravelin from 'ravelinjs/core+track+encrypt+promise';
import {
  CHECKOUT_SESSION_STORAGE_RAVELIN_DEVICE_FF,
  CHECKOUT_SESSION_STORAGE_RAVELIN_DEVICE_ID,
} from '~app/modules/checkout/constants';
import { AdditionalInformation } from '~app/modules/checkout/models/payment-additional-info.model';
import { environment } from '~env/environment';
import { FeatureToggleEnum } from '~shared/constants';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';

@Injectable({
  providedIn: 'root',
})
export class RavelinService {
  private ravelin;
  private ravelinDeviceId;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private featureFlagService: ActiveFeaturesConfigcatService
  ) {}

  public init() {
    if (isPlatformBrowser(this.platformId) && RavelinService.getFeatureFlagSession() && !this.ravelinDeviceId) {
      this.ravelinDeviceId = RavelinService.getFromSession();
      return;
    }
    this.featureFlagService
      .isFeatureEnabled(FeatureToggleEnum.FF_ENABLE_RAVELIN_DEVICE_ID)
      .subscribe((isRavelinEnabled) => {
        if (isPlatformBrowser(this.platformId) && isRavelinEnabled) {
          try {
            this.ravelin = new Ravelin({ key: environment.ravelinPublishableKey() });
            this.ravelin.core.id().then((deviceId) => {
              this.ravelinDeviceId = deviceId;
              this.updateSessionStorage();
            });
          } catch (e) {
            this.ravelin = null;
            this.ravelinDeviceId = null;
          }
        }
      });
  }

  get ravelinInstance() {
    return this.ravelin;
  }

  getRavelinDeviceId(): string {
    return this.ravelinDeviceId;
  }

  getRavelinObject(): Partial<Record<keyof Pick<AdditionalInformation, 'ravelinDeviceId'>, string>> {
    if (!this.getRavelinDeviceId()) {
      return {};
    }
    return { ravelinDeviceId: this.ravelinDeviceId };
  }

  private updateSessionStorage(): void {
    sessionStorage.setItem(CHECKOUT_SESSION_STORAGE_RAVELIN_DEVICE_ID, this.ravelinDeviceId);
    sessionStorage.setItem(CHECKOUT_SESSION_STORAGE_RAVELIN_DEVICE_FF, 'true');
  }

  static removeFromSession(): void {
    sessionStorage.removeItem(CHECKOUT_SESSION_STORAGE_RAVELIN_DEVICE_ID);
    sessionStorage.removeItem(CHECKOUT_SESSION_STORAGE_RAVELIN_DEVICE_FF);
  }

  private static getFromSession(): String | undefined {
    return sessionStorage.getItem(CHECKOUT_SESSION_STORAGE_RAVELIN_DEVICE_ID);
  }

  private static getFeatureFlagSession(): string | undefined {
    return sessionStorage.getItem(CHECKOUT_SESSION_STORAGE_RAVELIN_DEVICE_FF);
  }
}
